import React from 'react';

import styles from '../Integrations.module.scss';
import { Container, Row } from 'react-bootstrap';

import TopTextArea from '../Utils/TopTextArea';
import IntegrationLayout from '../Utils/Layout';
import InputArea from './InputArea';

import { hroneDetails } from '../Utils/constants';

export default function HROne(props) {
  return (
    <IntegrationLayout>
      <div className={styles.parentDivTopTextArea}>
        <TopTextArea title={'HROne'} icon={'hrone1.png'} />
        <Container>
          <div className='mt-5'>
            {hroneDetails.map((step, index) => {
              return (
                <Row>
                  <h6>
                    <span className='font-weight-bold'>Step {index + 1}:</span> {step}
                  </h6>
                </Row>
              );
            })}
          </div>
        </Container>
        <InputArea history={props.history} />
      </div>
    </IntegrationLayout>
  );
}
